import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const FloorBoardIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-floorBoard"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M51,1 L19,1 L19,33 L51,33 L51,1 Z M49,3 L49,31 L21,31 L21,3 L49,3 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M50 16 42 16 42 32 50 32 50 16ZM49 17 49 31 43 31 43 17 49 17ZM35 2 27 2 27 18 35 18 35 2ZM34 3 34 17 28 17 28 3 34 3Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M50,2 L34,2 L34,10 L50,10 L50,2 Z M49,3 L49,9 L35,9 L35,3 L49,3 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M50 9 34 9 34 17 50 17 50 9ZM49 10 49 16 35 16 35 10 49 10ZM36 17 20 17 20 25 36 25 36 17ZM35 18 35 24 21 24 21 18 35 18Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M36,24 L20,24 L20,32 L36,32 L36,24 Z M35,25 L35,31 L21,31 L21,25 L35,25 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M43 16 35 16 35 32 43 32 43 16ZM42 17 42 31 36 31 36 17 42 17ZM28 2 20 2 20 18 28 18 28 2ZM27 3 27 17 21 17 21 3 27 3Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M47 29C47 29.552 46.552 30 46 30 45.448 30 45 29.552 45 29 45 28.448 45.448 28 46 28 46.552 28 47 28.448 47 29M48 13C48 13.552 47.552 14 47 14 46.448 14 46 13.552 46 13 46 12.448 46.448 12 47 12 47.552 12 48 12.448 48 13M48 6C48 6.552 47.552 7 47 7 46.448 7 46 6.552 46 6 46 5.448 46.448 5 47 5 47.552 5 48 5.448 48 6M40 29C40 29.552 39.552 30 39 30 38.448 30 38 29.552 38 29 38 28.448 38.448 28 39 28 39.552 28 40 28.448 40 29M24 21C24 21.552 23.552 22 23 22 22.448 22 22 21.552 22 21 22 20.448 22.448 20 23 20 23.552 20 24 20.448 24 21M24 28C24 28.552 23.552 29 23 29 22.448 29 22 28.552 22 28 22 27.448 22.448 27 23 27 23.552 27 24 27.448 24 28M32 5C32 5.552 31.552 6 31 6 30.448 6 30 5.552 30 5 30 4.448 30.448 4 31 4 31.552 4 32 4.448 32 5M25 5C25 5.552 24.552 6 24 6 23.448 6 23 5.552 23 5 23 4.448 23.448 4 24 4 24.552 4 25 4.448 25 5"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="37 26 38 26 38 19 37 19"
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="26 30 33 30 33 29 26 29"
        />
        <polygon fill="#0050B3" className={styles.interactiveColor} points="36 5 43 5 43 4 36 4" />
      </g>
    </Icon>
  )
}
